/**
 * 注意：process.env.APP_VERSION 只用于开发环境区分国际和国外环境，
 * 测试和生产环境通过域名区分
 */
let appVersion = null
export const getAppVersion = () => {
  if (appVersion) {
    return appVersion
  }
  appVersion = process.env.APP_VERSION || (window.location.href.indexOf('campfiregames') > -1 ? "ZH" : "GLOBAL")
  return appVersion
}



// WEBPACK FOOTER //
// ./src/tool/index.js